<template>
    <div class="modifyAmountPort">
      <div class="Basics">
        <div-border label="基础信息" style="padding: 20px 20px 20px 40px">
          <div v-if="type ==='委托商港口对账单'||type ==='供应商港口对账单'">
            <div class="BasicsItem">
              <span class="span1">作业编号：</span>
              <span>{{BasicInformation.companyNameNew}}</span>
            </div>
            <div class="BasicsItem">
              <span class="span1">作业港口：</span>
              <span>{{BasicInformation.title}}</span>
            </div>
            <div class="BasicsItem">
              <span class="span1">作业类型：</span>
              <span>{{BasicInformation.title}}</span>
            </div>
            <div class="BasicsItem">
              <span class="span1">作业时间：</span>
              <span>{{BasicInformation.title}}</span>
            </div>
          </div>
          <div v-if="type ==='供应商托运费对账单'">
            <div class="BasicsItem">
              <span class="span1">运单编号：</span>
              <span>{{BasicInformation.companyNameNew}}</span>
            </div>
          </div>

          <div class="BasicsItem specialItem">
            <div class="specialOne">
              <span class="span1">批次号：</span>
              <span>{{BasicInformation.taxPrice}}</span>
            </div>
            <div>
              <span class="span1">底盘号：</span>
              <span>{{BasicInformation.noTaxPrice}}</span>
            </div>
          </div>
          <div class="BasicsItem specialItem">
            <div class="specialOne">
              <span class="span1">品牌：</span>
              <span>{{BasicInformation.taxPrice}}</span>
            </div>
            <div>
              <span class="span1">型号：</span>
              <span>{{BasicInformation.noTaxPrice}}</span>
            </div>
          </div>
        </div-border>
        <div-border label="金额修改" style="padding: 20px">
            <el-form :model="modigyData" label-width="110px" :rules="rules" ref="ruleForm">
            <el-form-item label="税率：" prop="taxRate">
              <el-input size="mini" v-model="modigyData.taxRate" placeholder="请输入税率">
                <i slot="suffix" class="input-right">%</i>
              </el-input>
            </el-form-item>
            <el-form-item label="含税合同价：" prop="taxPrice" >
              <el-input size="mini" v-model="modigyData.taxPrice" placeholder="请输入含税合同价">
                <i slot="suffix" class="input-right">元</i>
              </el-input>
            </el-form-item>
            <el-form-item label="税后：">
<!--              <el-input size="mini" v-model="modigyData.taxPrice" placeholder="请输入含税合同价">-->
<!--                <i slot="suffix" class="input-right">元</i>-->
<!--              </el-input>-->
              {{}}元
            </el-form-item>
          </el-form>

        </div-border>
        <div style="display: flex;justify-content: center;">
          <!--     提交按钮     -->
          <slot name="confirmButton" :modigyData="modigyData"></slot>
          <!--     取消按钮     -->
          <slot name="cancelButton"></slot>
<!--          <el-button class="searchBtn" size="mini">确定</el-button>-->
<!--          <el-button type="info" size="mini">取消</el-button>-->
        </div>
      </div>
    </div>
</template>

<script>
  import divBorder from "@/components/divBorder";
    export default {
        name: "modifyAmountPort",
      components:{
        divBorder
      },
      props:{
        BasicInformation:{
          type: Object,
          default:()=>{
            return{
              companyNameNew:"",
            }
          }
        },
        // 判断类型 如托运费，港口
        type: {
          default:""
        }
      },
      data(){
          return{
            modigyData:{
              taxRate:'',
              taxPrice:'',
            },
            rules:{
              taxRate:{required: true, message: '请输入税率', trigger: 'blur'},
              taxPrice:{required: true, message: '请输入含税合同价', trigger: 'blur'},
            },
          }
      },
      methods:{

      },
    }
</script>

<style lang="scss" scoped>
  .modifyAmountPort{
    padding: 25px;
    ::v-deep.Basics{
      &Item{
        margin-bottom: 20px;
        .imgContainer{
          display:flex;
          align-items: center;
        }
        .span1{
          font-weight: 700;
        }
        span{
          font-size: 14px;
        }
        .specialOne{
          width:50%;
        }
      }
      .specialItem{
        display:flex;
      }
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input{
        width: 350px;
      }
    }

  }
</style>
